import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/models/api-response.model';
import { BankAccount } from '@core/models/bank-account.model';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { MemberModule } from '../member.module';


@Injectable({
  providedIn: MemberModule
})
export class BankAccountDataService {

  messages$ = new Subject<any[]>();
  isSuccess: boolean;

  constructor(private http: HttpClient) { }

  getWithQuery(pageParam: string): Observable<BankAccount[]> {
    return this.http.get<ApiResponse>(`/bankaccount${pageParam}`).pipe(
      map(res => res.data.rows)
    );
  }

  addBank(bankAccount: BankAccount) {
    return this.http.post<ApiResponse>(`/bankaccount`, bankAccount).pipe(
      map(res => {
        this.messages$.next(res.message);
        this.isSuccess = res.success;
      })
    );
  }

  deleteBank(bankAccountId: number): Observable<BankAccount> {
    return this.http.delete<ApiResponse>(`/bankaccount/${bankAccountId}`).pipe(
      tap((res: any) => {
        this.messages$.next(res.message);
        this.isSuccess = res.success;
      })
    );
  }

  reupload(bankAccountId: number, document_path?: string): Observable<BankAccount> {
    return this.http.put<ApiResponse>(`/bankaccount/reupload/${bankAccountId}`, document_path).pipe(
      tap((res: any) => {
        this.messages$.next(res.message);
        this.isSuccess = res.success;
      })
    );
  }

  updateVerificationSeen(bankAccountId: number) {
    return this.http.put<ApiResponse>(`/bankaccount/updateseen/${bankAccountId}`, null).pipe();
  }

  getUnseenVerificationRecords(): Observable<any> {
    return this.http.get<ApiResponse>('/bankaccount/unseenverificationrecords').pipe(
      map(res => res.data)
    );
  }
}
